<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'elderApply'
}
</script>

<style>

</style>